export const YM_GOALS = {
	/* Регистрация пользователя */
	USER_REGISTRATION: 'USER_REGISTRATION',
	/* Успешная покупка продукта */
	PRODUCT_BUY_SUCCESS: 'PRODUCT_BUY_SUCCESS',
	/* Неуспешная покупка продукта */
	PRODUCT_BUY_FAILURE: 'PRODUCT_BUY_FAILURE',
	/* Для тестирования */
	TEST: 'TEST',
} as const;

export const YM_COUNTER_ID = process.env.NEXT_PUBLIC_METRIKA;
